import { Currency } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { InformationOutlinedIcon } from '@synergy/theme-next';
import { PoolModal, PoolModalContent, PoolTextButton } from '@synergy/components-next';
import { ReactElement, useState } from 'react';
import { TableCell, TableRow } from '@mui/material';

import { BonusConditionsPresenter } from '../../../../components/bonus-conditions-presenter/bonus-condition-presenter';
import { Conditions } from '../shared-components/conditions';
import { PriceSum } from '../shared-components/price-sum';
import { ShoppingCartSupplier } from '../../../../models/shopping-cart';

export interface SupplierTableRowProps {
    supplier: ShoppingCartSupplier;
    currency: Currency;
}

export const RowSumSupplierMobile = (props: SupplierTableRowProps): ReactElement => {
    const { surcharges, deliveryCosts, conditions, termsOfDelivery, paymentTerm, isChargingSupplier } = props.supplier;
    const { currency } = props;
    const [isModalShown, setIsModalShown] = useState(false);

    const getCosts = (): number => {
        let cost = 0;
        props.supplier.items.forEach(item => {
            cost += item.quantity * (item.product.specialPrice?.price ?? item.product.mainPrice);
        });
        return cost;
    };

    return (
        <TableRow>
            <TableCell sx={{ pt: 1, pb: 3 }}>
                <PoolTextButton
                    startIcon={<InformationOutlinedIcon />}
                    color="primary"
                    onClick={() => setIsModalShown(true)}
                    sx={{ height: 40, mb: 1 }}
                >
                    <FormattedMessage id={'app.cart.article.price.conditions'} />
                </PoolTextButton>

                <PoolModal open={isModalShown} onClose={() => setIsModalShown(false)} maxWidth="sm">
                    <PoolModalContent sx={{ padding: 2, textAlign: 'left' }}>
                        <Conditions
                            conditions={<BonusConditionsPresenter supplierConditions={conditions} />}
                            termsOfDelivery={termsOfDelivery}
                            termsOfPayment={paymentTerm}
                            isChargingSupplier={isChargingSupplier}
                        />
                    </PoolModalContent>
                </PoolModal>
                <PriceSum
                    surcharges={surcharges || 0}
                    deliveryCosts={deliveryCosts || 0}
                    articleCosts={getCosts()}
                    currency={currency}
                    isSubTotal={true}
                />
            </TableCell>
        </TableRow>
    );
};
